import React from 'react';

interface ErrorMessageProps {
  message: string;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ message }) => {
  return (
    <div className="bg-gradient-to-r from-red-50 to-red-100 text-red-800 border-2 border-red-500 
                   rounded-lg p-4 mb-6 font-medium animate-slideIn">
      <div className="flex items-center">
        <span className="text-xl mr-2">⚠️</span>
        {message}
      </div>
    </div>
  );
};

export default ErrorMessage;